import React from 'react'

const ContentError = (props) => {
  return (
    <div className="row">
      <div className="col-12">
        <div className="card rounded-0 vh-100 overflow-auto">
          <div className="card-body text-center">
            { window.t('course_viewer.unable_to_render') }
          </div>
        </div>
      </div>
    </div>
  )
}

export default ContentError